export default __webpack_public_path__ + "static/media/logo_max.bddcbfd5.svg";